module.exports = __webpack_public_path__ + "img/营地图标.b6084921.jpg";